import React from 'react';
export class Row extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("tr", { className: `${this.props.className} text-base-400`, style: this.props.style }, this.props.children)));
        };
    }
}
